import { isApiEnabled } from '@muzly/api-client';

import type { DiagnosisRecord } from '../record';

/**
 * 당겨서 복원 재시도(`PullToRefresh`)를 걸 수 있는 화면인가.
 *
 * 서버 이력 복원(`restoreDiagnoses`)은 **부팅에 한 번, 로컬이 비었을 때만** 돌고 2초
 * 상한이라, 재설치·앱 데이터 초기화 직후 그 안에 응답이 안 오면 회차가 없는 채로 남는다.
 * 그때 되살릴 수단이 앱 재시작뿐이었다 — 당겨서 다시 부르는 문을 연다.
 *
 * 두 조건을 다 봐야 제스처가 거짓말이 되지 않는다: 회차가 하나라도 있으면 복원은 스스로
 * 게이트에 걸려 아무 일도 안 하고, 서버가 꺼져 있으면(`isApiEnabled`) 부를 곳이 없다.
 * 홈과 이력이 같은 판단을 쓰므로 여기 한 벌만 둔다.
 */
export const canRetryDiagnosisRestore = (
  records: readonly DiagnosisRecord[],
): boolean => records.length === 0 && isApiEnabled();
